/*
 * @Author: your name
 * @Date: 2022-02-06 15:40:03
 * @LastEditTime: 2023-10-07 20:06:30
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyTextEditor\index.jsx
 */

import React, { Component } from 'react'
import { BsyUtils } from '../../utils/Utils';
import BsyMsgBubble from '../BsyMsgBubble';
import { BsyWidget } from '../BsyWidget';
import './index.css'

export default class BsyTimePicker extends BsyWidget {

  constructor(props) {
    super({
      baseCls: "bsy-datetime",
      triggerIcon: "icon-caret-down",
      waterMark: React.language("widget.timepicker.placeholder"),
      ...props
    })
    this.state = {
      value: this.options.value,
    }

  }

  getValue = () => {
    const { value } = this.state

    let a = value ? value[1] : null
      , b = value ? value[0] : null
      , c = [];
    c.push(b === '' ? null : b)
    c.push(a === '' ? null : a)
    return c
  }

  getContextMin = (context) => {
    this.min = context
  }


  getContextMax = (context) => {
    this.max = context
  }

  showValue = () => {

    const { value } = this.state
    if (BsyUtils.isObjectEmpty(value)) {
      return '';
    }

    let s = "";
    s += BsyUtils._dynamicStr(value ? value[0] : null);
    s += ' ~ '
    s += BsyUtils._dynamicStr(value ? value[1] : null);
    if (s === ' ~ ') {
      s = ''
    }
    return s;
  }


  _onTriggerClick = (event) => {

    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (ref) => {
        return <TimePicker
          value={this.state.value ? this.state.value : null}
          onDateUpdate={(c, closeFloat) => {

            this.setState({ value: c ? c : null }, () => {

              BsyUtils.applyFunc(this, this.options.onAfterEdit, [this.state.value, null, this], !1)
              BsyUtils.applyFunc(this, this.options.onStopEdit, [this.state.value, null, this], !1)
              if (closeFloat)
                ref.closeAlter()
            });

          }}

        />
      },
      text4Cancel: null,
      text4Ok: null,
      theme:this.props.theme,
      minWidth: 220,
      width: 220,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "center",
      onClose: function () {
        return !1;
      }
    })
  }

  render() {
    let that = this;
    const { cssName, waterMark, css } = this.options;
    const { value } = this.state

    return (
      <div className={cssName}
        onClick={this._onTriggerClick}
        style={css}
        ref={this.element}
      >
        <input className="bsy-trigger-input"
          onfocus="this.blur();"
          readonly="readOnly"
          unselectable="on"
          style={{height:'100%'}}
          placeholder={waterMark}
          defaultValue={this.showValue(value)}
          value={this.showValue(value)} />
      </div>
    )
  }
}

export class TimePicker extends BsyWidget {

  constructor(props) {
    super({
      baseCls: "bsy-time-picker",
      ...props
    })
    this.state = {
      value: this.options.value ? [...this.options.value] : [null, null],
      start: true,
    }
    this.curRows = [1];
    this.otherRows = [];
    for (let index = 1; index < 100; index++) {
      this.otherRows.push(index)
    }

    this.t1DomRef = React.createRef();
    this.t1DomWrapperRef = React.createRef();

    this.countDomRef = React.createRef();
    this.countDomWrapperRef = React.createRef();

    this.typeDomRef = React.createRef();
    this.typeDomWrapperRef = React.createRef();
  }

  setValue = (value, closeFloat) => {
    this.setState({
      value: value,
    }, () => {
      if (this.props.onDateUpdate)
        this.props.onDateUpdate(this.state.value, closeFloat)
    })
  }

  onChangeTime = (showValue) => {
    const { start } = this.state
    let val = showValue.t1 + showValue.count + showValue.type
    if (start) {
      this.setState({
        value: [
          val,
          this.state.value[1]
        ]
      })
    } else {
      this.setState({
        value: [
          this.state.value[0],
          val
        ]
      })
    }
  }

  caseT1 = (t1) => {
    switch (t1) {
      case "+": {
        return 0;

      }
      case "-": {
        return 32;

      }
      default: {
        return 64;
      }
    }
  }

  caseType = (type) => {
    switch (type) {
      case "M": {
        return 0;

      }
      case "w": {
        return 32;

      }
      default: {
        return 64;
      }
    }
  }

  caseCount = (count) => {
    return 96 - (count * 32)
  }

  onWheel = (t, type) => {

    var e = t.deltaY
    let i = 0;
    let n = {
      max: 64,
      min: 0
    }
    switch (type) {
      case "t1": {
        i = BsyUtils.elemoffset(this.t1DomWrapperRef.current).top - BsyUtils.elemoffset(this.t1DomRef.current).top - e
        n.min = 0;
        break;
      }
      case "count": {
        i = BsyUtils.elemoffset(this.countDomWrapperRef.current).top - BsyUtils.elemoffset(this.countDomRef.current).top - e
        n.min = 96 - (99 * 32)
        break;
      }
      case "type": {
        i = BsyUtils.elemoffset(this.typeDomWrapperRef.current).top - BsyUtils.elemoffset(this.typeDomRef.current).top - e
        n.min = 0;
        break;
      }
      default:
        i = BsyUtils.elemoffset(this.t1DomWrapperRef).top - BsyUtils.elemoffset(this.t1DomRef).top - e
        break;
    }

    i = Math.min(n.max, i);
    var s = 0;
    (i = Math.max(n.min, i)) > 0 ? s = 2 - Math.round(i / 32) : i < 0 ? s = -(Math.round(i / 32) - 2) : 0 === i && (s = 2)


    if (this.setI) {
      clearTimeout(this.setI)
      this.setI = null;
    }
    let that = this;
    this.setI = setTimeout(() => {
      switch (type) {

        case "count": {
          if (that.showValue.t1 !== "") {
            that.showValue.count = s + 1;
            that.onChangeTime(that.showValue)
          }

          break;
        }
        case "type": {
          that.showValue.type = "";
          if (s == 0) {
            that.showValue.type = "d";
          }
          if (s == 1) {
            that.showValue.type = "w";
          }
          if (s == 2) {
            that.showValue.type = "M";
          }
          this.onChangeTime(that.showValue)
          break;
        }
        case "t1":
        default:

          that.showValue.t1 = "";
          if (s == 0) {
            that.showValue.t1 = "";
          }
          if (s == 1) {
            that.showValue.t1 = "-";
          }
          if (s == 2) {
            that.showValue.t1 = "+";
          }
          that.onChangeTime(that.showValue)
          break;
      }
    }, 20)
  }

  render() {
    let that = this;

    const { value, start } = this.state
    this.showValue = {}
    if (start) {
      this.showValue = BsyUtils._dynamicTime(value[0])
    } else {
      this.showValue = BsyUtils._dynamicTime(value[1])
    }
    return (

      <div className="bsy-time-picker" style={{
        width: 220
      }}>
        <div className="head-tab">
          <div className={"tab-btn " + (start ? 'select' : '')}   >
            <div onClick={() => {
              this.setState({
                start: true,
              })
            }} className="btn-text" data-watermark={React.language('timeBegin')}>{BsyUtils._dynamicStr(value[0])}</div>
            <i onClick={() => {
              this.setState({
                value: [
                  null,
                  this.state.value[1],
                ]
              })
            }} className="icon-close-circle clear-btn"></i>
          </div>
          <div className="tab-separator">~</div>
          <div className={"tab-btn " + (!start ? 'select' : '')}  >
            <div onClick={() => {
              this.setState({
                start: false,
              })
            }} className="btn-text" data-watermark={React.language('timeEnd')}>{BsyUtils._dynamicStr(value[1])}</div>
            <i onClick={() => {
              this.setState({
                value: [
                  this.state.value[0],
                  null,
                ]
              })
            }} className="icon-close-circle clear-btn"></i>
          </div>
        </div>
        <div className="body">
          <div ref={this.t1DomRef} className="body-col" onWheel={(e) => {
            this.onWheel(e, "t1")
          }} >
            <div ref={this.t1DomWrapperRef} className="col-wrapper transition" style={{
              "transform": "translate(0px, " + (this.caseT1(this.showValue.t1)) + "px)"
            }}>
              <div className={"col-item " + (!this.showValue.t1 ? "select" : "")}>
                <div onClick={() => {
                  this.showValue.t1 = "";
                  this.onChangeTime(this.showValue)
                }} className="item-wrapper">{React.language('current')}</div>
              </div>
              <div className={"col-item " + (this.showValue.t1 === '-' ? "select" : "")}>
                <div onClick={() => {
                  this.showValue.t1 = "-";
                  this.onChangeTime(this.showValue)
                }} className="item-wrapper">{React.language('past')}</div>
              </div>
              <div className={"col-item " + (this.showValue.t1 === '+' ? "select" : "")}>
                <div onClick={() => {
                  this.showValue.t1 = "+";
                  this.onChangeTime(this.showValue)
                }} className="item-wrapper">{React.language('future')}</div>
              </div>
            </div>
          </div>
          <div ref={this.countDomRef} className="body-col" onWheel={(e) => {
            this.onWheel(e, "count")
          }}>
            <div ref={this.countDomWrapperRef} className="col-wrapper transition" style={{
              "transform": "translate(0px, " + this.caseCount(this.showValue.count) + "px)"
            }}>
              {
                this.showValue.t1 == '' ? this.curRows.map((data, index) => {
                  return <div key={'dd' + index} className={"col-item " + (data == this.showValue.count ? 'select' : '')}>
                    <div onClick={() => {
                      this.showValue.count = data;
                      this.onChangeTime(this.showValue)
                    }} className="item-wrapper">{data}</div>
                  </div>
                }) : this.otherRows.map((data, index) => {
                  return <div key={'dd' + index} className={"col-item " + (data == this.showValue.count ? 'select' : '')}>
                    <div onClick={() => {
                      this.showValue.count = data;
                      this.onChangeTime(this.showValue)
                    }} className="item-wrapper">{data}</div>
                  </div>
                })
              }


            </div>
          </div>
          <div ref={this.typeDomRef} className="body-col" onWheel={(e) => {
            this.onWheel(e, "type")
          }}>
            <div ref={this.typeDomWrapperRef} className="col-wrapper transition" style={{
              "transform": "translate(0px, " + (this.caseType(this.showValue.type)) + "px)"
            }}>
              <div className={"col-item " + (this.showValue.type === 'd' ? "select" : "")}>
                <div onClick={() => {
                  this.showValue.type = "d";
                  this.onChangeTime(this.showValue)
                }} className="item-wrapper">{React.language('day')}</div>
              </div>
              <div className={"col-item " + (this.showValue.type === 'w' ? "select" : "")}>
                <div onClick={() => {
                  this.showValue.type = "w";
                  this.onChangeTime(this.showValue)
                }} className="item-wrapper">{React.language('week')}</div>
              </div>
              <div className={"col-item " + ((this.showValue.type === 'M') ? "select" : "")}>
                <div onClick={() => {
                  this.showValue.type = "M";
                  this.onChangeTime(this.showValue)
                }} className="item-wrapper">{React.language('month')}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="btn-group">
            <div onClick={() => {
              this.setValue([null, null], false)
            }} className="group-btn">{React.language('clear')}</div>
            <div onClick={() => {
              if (this.props.onDateUpdate)
                this.props.onDateUpdate(this.state.value, true)
            }} className="group-btn style-green">{React.language('ok')}</div>
          </div>
        </div>
      </div>
    )
  }
}